/* eslint-disable camelcase */
import InventoryResourceGroups from './Domains/InventoryResourceGroups';
import Registry from './Domains/Registry';

export const defaultCompany = () => Registry.get('/accounts');

export const permissionProfiles = () => Registry.get('/profiles');

export const companyUsers = (company_id, filter) =>
  Registry.get(`/accounts/${company_id}/users?${filter}`);

export const getResourceGroups = (company_id) =>
  InventoryResourceGroups.get(`/companies/${company_id}/resource_groups`);

export const createCompanyUser = (company_id, payload) =>
  Registry.post(`/accounts/${company_id}/users`, payload);

export const updateCompanyUser = (company_id, user_id, payload) =>
  Registry.patch(`/accounts/${company_id}/user/${user_id}`, payload);

export const deleteCompanyUser = (company_id, userId) =>
  Registry.delete(`/accounts/${company_id}/user/${userId}`);
